import { Permit } from "../../models/Permit";
import { User } from "../../models/User";
import { RawFile } from "../../models/RawFile";
import { LocationLog } from "../../models/LocationLog";
import { LocationErrorCode } from "../../LocationService";

// Constants
export const LOAD_PERMIT_STARTED = "LOAD_PERMIT_STARTED";
export const LOAD_PERMIT_SUCCESSFUL = "LOAD_PERMIT_SUCCESSFUL";
export const LOAD_PERMIT_FAILED = "LOAD_PERMIT_FAILED";
export const SAVE_PERMIT_STARTED = "SAVE_PERMIT_STARTED";
export const SAVE_PERMIT_SUCCESSFUL = "SAVE_PERMIT_SUCCESSFUL";
export const SAVE_PERMIT_FAILED = "SAVE_PERMIT_FAILED";
export const LOAD_PERMIT_SUBMITTER_SUCCESSFUL = "LOAD_PERMIT_SUBMITTER_SUCCESSFUL";
export const UPDATE_PERMIT_LAST_ACCESS_SUCCESSFUL = "UPDATE_PERMIT_LAST_ACCESS_SUCCESSFUL";
export const UPDATE_PERMIT_LAST_ACCESS_FAILED = "UPDATE_PERMIT_LAST_ACCESS_FAILED";
export const REPORT_PROBLEM = "REPORT_PROBLEM";
export const WORK_COMPLETED = "WORK_COMPLETED";
export const CONVERT_SITE_PHOTOS_FILE_KEYS_TO_SITE_PHOTOS = "CONVERT_SITE_PHOTOS_FILE_KEYS_TO_SITE_PHOTOS";

// State Type
export interface PermitState {
    loading: boolean;
    saving: boolean;
    permit: Permit | null;
    permitGeofenceCheckResult: {
        isWithinGeofence: boolean;
        error: string | null;
        errorCode: LocationErrorCode | null;
    } | null;
    permitSubmitter: User | null;
    newFiles: RawFile[];
    permitGangMemberUpdateMessage: string;
}

// Action Types
interface LoadPermitStartedAction {
    type: typeof LOAD_PERMIT_STARTED;
}

interface LoadPermitSuccessfulAction {
    type: typeof LOAD_PERMIT_SUCCESSFUL;
    permit: Permit;
}

interface LoadPermitFailedAction {
    type: typeof LOAD_PERMIT_FAILED;
    error: Error;
}

interface SavePermitStartedAction {
    type: typeof SAVE_PERMIT_STARTED;
}

interface SavePermitSuccessfulAction {
    type: typeof SAVE_PERMIT_SUCCESSFUL;
    permit: Permit;
}

interface SavePermitFailedAction {
    type: typeof SAVE_PERMIT_FAILED;
    error: Error;
}

interface LoadPermitSubmitterSuccessfulAction {
    type: typeof LOAD_PERMIT_SUBMITTER_SUCCESSFUL;
    user: User;
}

interface updatePermitLastAccessSuccessfulAction {
    type: typeof UPDATE_PERMIT_LAST_ACCESS_SUCCESSFUL;
    locationLog: LocationLog;
    permitId: string;
}

interface updatePermitLastAccessSuccessfulAction {
    type: typeof UPDATE_PERMIT_LAST_ACCESS_SUCCESSFUL;
    locationLog: LocationLog;
    permitId: string;
    withinGeofence: boolean;
    geofencingError: string | null;
}

interface updatePermitLastAccessFailedAction {
    type: typeof UPDATE_PERMIT_LAST_ACCESS_FAILED;
    error: string;
    permitId: string;
    errorCode: LocationErrorCode | null;
}

interface reportProblemAction {
    type: typeof REPORT_PROBLEM;
    comments: string;
    loggedInUserId: string;
}

interface workCompletedAction {
    type: typeof WORK_COMPLETED;
    loggedInUserId: string;
}

interface convertSitePhotosFileKeysToSitePhotosAction {
    type: typeof CONVERT_SITE_PHOTOS_FILE_KEYS_TO_SITE_PHOTOS;
}

export type PermitActionTypes =
    | LoadPermitStartedAction
    | LoadPermitSuccessfulAction
    | LoadPermitFailedAction
    | SavePermitStartedAction
    | SavePermitSuccessfulAction
    | SavePermitFailedAction
    | LoadPermitSubmitterSuccessfulAction
    | updatePermitLastAccessSuccessfulAction
    | updatePermitLastAccessFailedAction
    | reportProblemAction
    | workCompletedAction
    | convertSitePhotosFileKeysToSitePhotosAction;
